/**
 * Trimmed vendored subset of `services`' `src/shared/node/Errors.ts`.
 *
 * The original file pulls in `apollo-server-errors` (a backend/GraphQL-server
 * dependency, out of scope per the extraction plan — BookingTools/App only
 * ever CONSTRUCTS these two error classes in its test mocks, it never runs
 * inside an Apollo Server). Only the two error classes actually referenced
 * by BookingTools/App's mocks (`UserInputError`, `CardPaymentError`) are
 * reproduced here, extending `GraphQLError` from the `graphql` package
 * (already a real dependency of this repo, and what `apollo-server-errors`'
 * `UserInputError` itself ultimately extends) instead of vendoring the whole
 * module (which would otherwise pull in `apollo-server-errors`). See
 * VENDORED.md.
 */

import { GraphQLError } from "graphql";

export class UserInputError extends GraphQLError {
  constructor(message: string, extensions?: Record<string, unknown>) {
    super(
      message,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      // `apollo-server-errors`' real `UserInputError` always sets
      // `extensions.code = "BAD_USER_INPUT"` — several BookingTools/App
      // callers branch on this code, so it's reproduced here even though
      // this trimmed class no longer extends the real apollo-server-errors
      // class.
      { code: "BAD_USER_INPUT", ...extensions },
    );
  }
}

export class CardPaymentError extends UserInputError {
  constructor(message: string, responseCode: number) {
    super(
      `Card declined with response code ${responseCode} & error: ${message}.`,
      {
        appointeddErrorCode: "CARD_PAYMENT_ERROR",
      },
    );
  }
}
